import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";

export const getAddressFromCin = (cin: string) => {
  const sessionid = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}business/fetch/cin`,
      {
        params: {
          karza_key: "47QlOJ9cG9A0QNH",
          cin: `${cin}`,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((response): any => response.data)
    .catch((err) => err);
};
